import React from "react";

import classnames from "classnames";
import BoltIcon from "Intuit/BoltIcon";
import isIntuit from "Intuit/isIntuit";
import PropTypes from "prop-types";
import _ from "underscore";
import simplifyPlanName from "Utils/simplifyPlanName";

import BodyText from "Common/BodyText";
import { CarrierLogoFlexbox } from "Common/CarrierLogo";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

const bem = makeBem("SavedPlanBox");

const RemoveIcon = ({ planID, toggleSavePlan }) =>
  isIntuit() ? (
    <BoltIcon
      icon="delete"
      aria-label="remove"
      className={classnames(bem("remove"), bem("remove", "intuit"))}
      onClick={() => toggleSavePlan(planID, "saved_plan_box")}
    />
  ) : (
    <Icon
      aria-label="remove"
      icon="minus-circle"
      float="right"
      flavor="regular"
      className={bem("remove")}
      onClick={() => toggleSavePlan(planID, "saved_plan_box")}
    />
  );

const PlanInformation = ({ planID, shouldShowSimplePlanName, plan, toggleSavePlan, isLoading }) => {
  const displayName = isLoading || !plan ? "Loading..." : shouldShowSimplePlanName ? simplifyPlanName(plan) : plan.display_name;

  // If data has loaded and the plan is no longer offered, do not render
  if (!isLoading && !plan) {
    return null;
  }

  return (
    <div className={bem("PlanInformation")}>
      <Div className={bem("logo")} pb={2} pt={1} pl={2}>
        {isLoading ? <Icon icon="spinner" spin="pulse" mr="auto" /> : <CarrierLogoFlexbox plan={plan} maxSize={1} />}
      </Div>
      <BodyText size={isIntuit() ? "medium" : "ns-twelve"} weight={isIntuit() ? "bold" : "normal"} className={bem("text")}>
        {displayName}
      </BodyText>
      <Div className={bem("RemoveIcon")}>
        <RemoveIcon planID={planID} toggleSavePlan={toggleSavePlan} />
      </Div>
    </div>
  );
};

const SavedPlanBox = ({ plan, planID, isLoading, toggleSavePlan, shouldShowSimplePlanName, ...rest }) => {
  const missingPlanInformation = !plan && !isLoading;
  return isIntuit() && missingPlanInformation ? null : (
    <Div
      className={classnames(bem(), {
        [bem(null, "intuit")]: isIntuit(),
      })}
      p={isIntuit() ? 2 : 3}
      {...rest}
    >
      <PlanInformation planID={planID} shouldShowSimplePlanName={shouldShowSimplePlanName} plan={plan} toggleSavePlan={toggleSavePlan} isLoading={isLoading} />
    </Div>
  );
};

SavedPlanBox.propTypes = {
  plan: PropTypes.object,
  isLoading: PropTypes.bool,
  toggleSavePlan: PropTypes.func.isRequired,
};
export default SavedPlanBox;
